// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/styles/" + "styles" + "." + "87ecbb35e821e976d474" + ".css";
};